/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated';
import { divideDependencies } from './dependenciesDivide.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMeanTransform } from '../../factoriesAny.js';
export var meanTransformDependencies = {
  addDependencies: addDependencies,
  divideDependencies: divideDependencies,
  typedDependencies: typedDependencies,
  createMeanTransform: createMeanTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMeanTransform.generated.js
// module id = 1590
// module chunks = 0